import { render, staticRenderFns } from "./PlansCard.vue?vue&type=template&id=d8122e92"
import script from "./PlansCard.vue?vue&type=script&lang=js"
export * from "./PlansCard.vue?vue&type=script&lang=js"
import style0 from "./PlansCard.vue?vue&type=style&index=0&id=d8122e92&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports